import { render, staticRenderFns } from "./DatatableRowActions.vue?vue&type=template&id=ef510f0a&"
import script from "./DatatableRowActions.vue?vue&type=script&lang=js&"
export * from "./DatatableRowActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports